import { useCallback, useContext, useEffect, useState } from "react";
import { CreateContext } from "../../../contexts/CreateContext";
import { IconContainer } from "../../Buttons/IconContainer";
import { OrderGalleryList } from "../Gallery/OrderGalleryList";
import { NextButton } from "../Navigation/NextButton";
import { PrevButton } from "../Navigation/PrevButton";
import { StepNavContainer } from "../Navigation/StepNavContainer";
import { UploadProgressBar } from "../UploadProgressBar/UploadProgressBar";
import GalleryIcon from "../../../public/images/icons/photo.svg";
import useTranslation from "next-translate/useTranslation";

export const GalleryStep = () => {
    const { uploadManager, galleryItems, setGalleryItems, reset, setStep } = useContext(CreateContext);
    const { t } = useTranslation('create');

    const onPrev = () => {
        reset();
    }

    const onNext = () => {
        setStep("info");
    }

    useEffect(() => {
        if (galleryItems.length === 1) {
            setStep("info");
        }

    }, [galleryItems]);

    return (
        <>
            <StepNavContainer>
                <PrevButton onPrev={onPrev} />
            </StepNavContainer>
            <div className="mb-6 w-full items-center flex flex-row flex-wrap gap-x-2 justify-center text-center">
                <GalleryIcon className="w-8 h-8 text-primary" />
                <h3>{t('galleryStep.title')}</h3>
            </div>
            <p className="text-base font-normal mb-10 text-center">{t('galleryStep.subtitle')}</p>
            <OrderGalleryList items={galleryItems} setItems={setGalleryItems} />
            <UploadProgressBar />
            <StepNavContainer className="w-full flex justify-end mt-8">
                <NextButton onNext={onNext} label={t('continue')} />
            </StepNavContainer>
        </>
    );
}